import FBtnMDP from "@/components/FBtnMDP";
import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";
import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FNumberFieldMDP from "@/components/form/field/FNumberFieldMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";
import * as Action from "@/../src-gen/action";
import * as Data from "@/../src-gen/data";
import FSnackbar from "@/fsnackbar";
import FFormDrawerMDP from "@/components/form/FFormDrawerMDP";

export default class FUpdateCreditScoreFFormMDP extends FFormDrawerMDP {
    childMDP = new FFormChildMDP();
    taskRoot: any;
    parent: any;
    constructor({ taskRoot, parent }: { taskRoot: any; parent: any }) {
        super({ myRefName: "fUpdateCreditScoreFFormRef", onClose: () => {parent.closeAndClearAllForms()},isVisible:parent.addCreditScoreDialog, title:"Update Credit Score" });
        this.parent = parent;
        this.taskRoot = taskRoot;
        this.addField(new FNumberFieldMDP({
            parentMDP: this.childMDP,
            dataSelectorKey: "creditScore",
            label: "Credit Score",
            boundaryClass: "col-6",
            mandatory: true
        })).addField(new FSelectFieldMDP({
            parentMDP: this.childMDP,
            dataSelectorKey: "creditBureau",
            label: "Credit Bureau",
            options: Data.ClientFile.CreditBureau.list(),
            optionLabel: "name",
            optionValue: "id",
            boundaryClass: "col-6",
            mandatory: true
        })).addAction(new FBtnMDP({
            label: "Cancel",
            onClick: this.closeAndClearAllForms()
        })).addAction(new FFormSubmitBtnMDP({
            label: "Update Credit Score",
            onClick: () => this.handleUpdateCreditScore()
        }))
    }

    handleUpdateCreditScore() {

        this.parent.updateCreditScoreForm.clientFileId = (
            this.taskRoot as any
        ).clientFileBasicInfo.clientFileId;
        Action.ClientFile.UpdateCreditInfo.execute(this.parent.updateCreditScoreForm, output => {
            this.parent.closeAndClearAllForms();
        });
    }


    getMyRef() {
        return this.parent.$refs[this.myRefName];
    }


    closeAndClearAllForms() {
        return () => {
            this.parent.closeAndClearAllForms();
        }
    }
}